'use strict';

exports.__esModule = true;
exports['default'] = displayName;

var _validators = require('../../utils/validators');

function displayName(name) {
  return function (target) {
    (0, _validators.validateClass)(target, 'displayName');

    // eslint-disable-next-line
    target.displayName = name;
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/react-decoration/lib/decorators/components/displayName.js
// module id = 548
// module chunks = 1